import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnHU: CultureInfo = {
  name: 'en-HU',
  displayName: 'English (Hungary)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-HU',
  parent: CultureInfoEn
};
